import {CreditInvoiceItem} from './CreditInvoiceItem';
import {FileManager} from '../../shared/Models/FileManager';
import {InvoiceDealer} from './InvoiceDealer';
import {CustomerDeliveryAddress} from './CustomerDeliveryAddress';

export class InvoiceCustom  {
  public id?: number;
  public invoiceDealer: any|InvoiceDealer;
  public invoiceLayout: number;
  public isCredit: number;
  public customInvoiceItems: CreditInvoiceItem[] = [];
  public creditInvoiceItems: CreditInvoiceItem[] = [];
  public replyItem?: any;
  public FileManager?: FileManager;
  public isCustomerInvoice?: boolean;
  public customerDetail?: CustomerDeliveryAddress;
}
